import { Box } from "@chakra-ui/react";
import PublicContent from "../content/PublicContent";

export default function Guide() {
  return <Box bg="gray.50" minH="100vh" p={{ base: 4, md: 8 }}><PublicContent page="guide" standalone /></Box>;
}
